import { useToast } from '@/components/atoms/Toast';
import { sendAnalytics } from '@/services/analyticsService';
import { removeBusinessFromList } from '@/services/listsService';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseRemoveBusinessMutationProps = {
	listId: string;
	currentPage: number;
	totalElements: number;
	onPreviousPage: VoidFunction;
	refetch: VoidFunction;
};

export const useRemoveBusinessMutation = ({
	currentPage,
	totalElements,
	onPreviousPage,
	refetch
}: UseRemoveBusinessMutationProps) => {
	const queryClient = useQueryClient();
	const { toast } = useToast();

	return useMutation({
		mutationFn: removeBusinessFromList,
		onSuccess: (data, variables) => {
			if (currentPage > 0 && totalElements === 1) {
				onPreviousPage();
			}

			queryClient.invalidateQueries(['list-details-business-data']);
			refetch();

			toast({
				title: 'Business removed from list',
				variant: 'success'
			});

			const { businessId, listId } = variables;

			sendAnalytics({
				type: 'track',
				eventName: 'User removed an item from list',
				properties: {
					businessId,
					listId,
					listName: data.data.data.name
				}
			});
		},
		onError: () => {
			toast({
				title: 'Something went wrong with business deletion',
				variant: 'error'
			});
		}
	});
};
